module.exports = __webpack_public_path__ + "static/media/avatar_disabled.3a917de2.svg";